import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_loader = _resolveComponent("user-loader")!
  const _component_customer_user_dashboard = _resolveComponent("customer-user-dashboard")!
  const _component_client_user_dashboard = _resolveComponent("client-user-dashboard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.userId)
      ? (_openBlock(), _createBlock(_component_user_loader, {
          key: 0,
          "user-id": _ctx.userId,
          modelValue: _ctx.user,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event))
        }, null, 8, ["user-id", "modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.isCustomerUser)
      ? (_openBlock(), _createBlock(_component_customer_user_dashboard, { key: 1 }))
      : (_ctx.user && _ctx.isClientUser)
        ? (_openBlock(), _createBlock(_component_client_user_dashboard, {
            key: 2,
            "client-id": _ctx.user.clientId
          }, null, 8, ["client-id"]))
        : _createCommentVNode("", true)
  ]))
}